/* ThinkLoop's preferences for the delight layer (src/delight). Theme, sound and font size
   live elsewhere: utils/themes.js, delight/sounds.ts and utils/fontSize.js.
   Keep the keys in sync with the inline script in public/index.html. */

export const PREF_KEYS = {
  sparkle: "thinkloop-sparkle",
  motion: "thinkloop-motion",
} as const;

export const PREFS_EVENT = "thinkloop:prefs";

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage can be blocked; the choice still applies for this visit
  }
  window.dispatchEvent(new Event(PREFS_EVENT));
}

/* The click sparkle is on unless turned off */
export const getSparkle = () => read(PREF_KEYS.sparkle) !== "off";
export const setSparkle = (on: boolean) => write(PREF_KEYS.sparkle, on ? "on" : "off");

/* Reduce motion: the system setting, or the Settings switch (data-motion="reduce" on <html>) */
export const systemReducesMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
export const getReduceMotion = () => document.documentElement.dataset.motion === "reduce";
export const prefersReducedMotion = () => systemReducesMotion() || getReduceMotion();

export function setReduceMotion(on: boolean) {
  if (on) document.documentElement.dataset.motion = "reduce";
  else delete document.documentElement.dataset.motion;
  write(PREF_KEYS.motion, on ? "reduce" : "off");
}

/* ThinkLoop is never zoomed */
export const getZoom = () => 1;

